var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-image"},[_c('img',{attrs:{"loading":"lazy","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }